import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ExternalLink, Gamepad2 } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const JogosPage = () => {
  const jogosSites = [
    {
      name: "Free Puzzles Games",
      url: "https://freepuzzlesgames.com/game/5239/Space_Adventure.html",
      description: "Jogos de puzzle gratuitos para todas as idades. Desafios para o cérebro, quebra-cabeças e muito mais.",
      imageUrl: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-O4lkLHwXsXrZdg9IXl1xMJHN/user-3t7Gu7USXXYQJfFCzCfnULQT/img-YrpjLNdCmWpGYMZFurljxzOA.png?st=2024-08-04T02%3A10%3A33Z&se=2024-08-04T04%3A10%3A33Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2024-08-04T02%3A40%3A57Z&ske=2024-08-05T02%3A40%3A57Z&sks=b&skv=2021-08-06&sig=XXsQjdT%2BDpq4NJTL8Fdf3nmFwZXTuZ8FFrPkAXRlXgs%3D",
      category: "puzzles"
    },
    {
      name: "UFree Games",
      url: "https://www.ufreegames.com/",
      description: "Jogos online gratuitos para jogar diretamente no seu navegador. Jogos de ação, aventura, estratégia e muito mais.",
      imageUrl: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-O4lkLHwXsXrZdg9IXl1xMJHN/user-3t7Gu7USXXYQJfFCzCfnULQT/img-OEw9Gxm1KxUAZgqZRPUmN8lB.png?st=2024-08-04T02%3A10%3A54Z&se=2024-08-04T04%3A10%3A54Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2024-08-04T02%3A37%3A54Z&ske=2024-08-05T02%3A37%3A54Z&sks=b&skv=2021-08-06&sig=U4hqsR/vKc3Q5q/rXfgLEtgTXmjEAQS7Qs8HwZrGnH0%3D",
      category: "variados"
    },
    {
      name: "Crazy Games",
      url: "https://www.crazygames.com.br/",
      description: "Jogos malucos e divertidos para todos os gostos. Plataforma brasileira com milhares de jogos gratuitos.",
      imageUrl: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-O4lkLHwXsXrZdg9IXl1xMJHN/user-3t7Gu7USXXYQJfFCzCfnULQT/img-mZqr9L7uORdqhPluVn3FKOYC.png?st=2024-08-04T02%3A11%3A14Z&se=2024-08-04T04%3A11%3A14Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2024-08-03T23%3A09%3A36Z&ske=2024-08-04T23%3A09%3A36Z&sks=b&skv=2021-08-06&sig=HVaVxW6SbrUXXfxjJELx2m7FNnR%2BUbdFP1sR0qFRfz0%3D",
      category: "variados"
    },
    {
      name: "Poki",
      url: "https://poki.com/br",
      description: "Plataforma popular com jogos gratuitos online para todas as idades. Inclui jogos de ação, esportes, corrida e muito mais.",
      imageUrl: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-O4lkLHwXsXrZdg9IXl1xMJHN/user-3t7Gu7USXXYQJfFCzCfnULQT/img-jnKKw2Eqmb0uyOdD3HBZLBsF.png?st=2024-08-04T02%3A11%3A31Z&se=2024-08-04T04%3A11%3A31Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2024-08-04T00%3A43%3A16Z&ske=2024-08-05T00%3A43%3A16Z&sks=b&skv=2021-08-06&sig=HXeaUHUqMXXe0Rqa9/MvlwxhLxCFLuTDxR3okYX3/s8%3D",
      category: "variados"
    },
    {
      name: "Click Jogos",
      url: "https://www.clickjogos.com.br/",
      description: "Um dos maiores portais de jogos online do Brasil, com jogos para todos os gostos e idades.",
      imageUrl: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-O4lkLHwXsXrZdg9IXl1xMJHN/user-3t7Gu7USXXYQJfFCzCfnULQT/img-vYGjDMrOpJwt4h2bTkGxzuTN.png?st=2024-08-04T02%3A11%3A48Z&se=2024-08-04T04%3A11%3A48Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2024-08-04T02%3A36%3A13Z&ske=2024-08-05T02%3A36%3A13Z&sks=b&skv=2021-08-06&sig=XlmDk5HzjvVIXGLh2Qj1gzm2fB8lcgPRXq8dfmzIKEI%3D",
      category: "variados"
    },
  ];

  const giphyInfo = {
    name: "GIPHY - Meu Canal",
    url: "https://giphy.com/channel/edvaldojose3d3b",
    description: "Meu canal no GIPHY com uma coleção de GIFs animados para usar em suas conversas e redes sociais.",
    imageUrl: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-O4lkLHwXsXrZdg9IXl1xMJHN/user-3t7Gu7USXXYQJfFCzCfnULQT/img-rCTfIJGtOxBzr3kYgmcXGBp4.png?st=2024-08-04T02%3A12%3A08Z&se=2024-08-04T04%3A12%3A08Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2024-08-04T02%3A35%3A17Z&ske=2024-08-05T02%3A35%3A17Z&sks=b&skv=2021-08-06&sig=1FfFZyNH8b5tWYOAPcCc8ZPkY6ZyzxrXSRN5Gf8HkPw%3D"
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="space-y-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent py-2">
              Sites de Jogos
            </h1>
            <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
              Confira esta seleção de sites com jogos online gratuitos para se divertir.
              Jogos de todos os tipos para jogar diretamente no seu navegador.
            </p>
          </div>

          <Tabs defaultValue="todos" className="w-full">
            <TabsList className="grid grid-cols-3 max-w-md mx-auto mb-8">
              <TabsTrigger value="todos">Todos</TabsTrigger>
              <TabsTrigger value="variados">Variados</TabsTrigger>
              <TabsTrigger value="puzzles">Puzzles</TabsTrigger>
            </TabsList>
            
            <TabsContent value="todos" className="mt-0">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {jogosSites.map((site, index) => (
                  <Card key={index} className="overflow-hidden transition-all hover:shadow-lg">
                    <CardHeader className="p-0">
                      <div className="aspect-video w-full overflow-hidden">
                        <img 
                          src={site.imageUrl} 
                          alt={site.name} 
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                      <CardTitle className="flex items-center gap-2">
                        <Gamepad2 className="h-5 w-5 text-primary" />
                        {site.name}
                      </CardTitle>
                      <CardDescription className="mt-2 text-muted-foreground">
                        {site.description}
                      </CardDescription>
                    </CardContent>
                    <CardFooter>
                      <Button asChild className="w-full">
                        <a href={site.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                          <span>Visitar Site</span>
                          <ExternalLink className="h-4 w-4" />
                        </a>
                      </Button>
                    </CardFooter>
                  </Card>
                ))}
              </div>
            </TabsContent>
            
            <TabsContent value="variados" className="mt-0">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {jogosSites.filter(site => site.category === "variados").map((site, index) => (
                  <Card key={index} className="overflow-hidden transition-all hover:shadow-lg">
                    <CardHeader className="p-0">
                      <div className="aspect-video w-full overflow-hidden">
                        <img 
                          src={site.imageUrl} 
                          alt={site.name} 
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                      <CardTitle className="flex items-center gap-2">
                        <Gamepad2 className="h-5 w-5 text-primary" />
                        {site.name}
                      </CardTitle>
                      <CardDescription className="mt-2 text-muted-foreground">
                        {site.description}
                      </CardDescription>
                    </CardContent>
                    <CardFooter>
                      <Button asChild className="w-full">
                        <a href={site.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                          <span>Visitar Site</span>
                          <ExternalLink className="h-4 w-4" />
                        </a>
                      </Button>
                    </CardFooter>
                  </Card>
                ))}
              </div>
            </TabsContent>
            
            <TabsContent value="puzzles" className="mt-0">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {jogosSites.filter(site => site.category === "puzzles").map((site, index) => (
                  <Card key={index} className="overflow-hidden transition-all hover:shadow-lg">
                    <CardHeader className="p-0">
                      <div className="aspect-video w-full overflow-hidden">
                        <img 
                          src={site.imageUrl} 
                          alt={site.name} 
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                      <CardTitle className="flex items-center gap-2">
                        <Gamepad2 className="h-5 w-5 text-primary" />
                        {site.name}
                      </CardTitle>
                      <CardDescription className="mt-2 text-muted-foreground">
                        {site.description}
                      </CardDescription>
                    </CardContent>
                    <CardFooter>
                      <Button asChild className="w-full">
                        <a href={site.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                          <span>Visitar Site</span>
                          <ExternalLink className="h-4 w-4" />
                        </a>
                      </Button>
                    </CardFooter>
                  </Card>
                ))}
              </div>
            </TabsContent>
          </Tabs>

          <div className="border-t border-border pt-12 mt-16">
            <h2 className="text-3xl font-bold text-center mb-8">Meu Canal GIPHY</h2>
            <div className="max-w-2xl mx-auto">
              <Card className="overflow-hidden transition-all hover:shadow-lg">
                <CardHeader className="p-0">
                  <div className="aspect-video w-full overflow-hidden">
                    <img 
                      src={giphyInfo.imageUrl} 
                      alt={giphyInfo.name} 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </CardHeader>
                <CardContent className="pt-6">
                  <CardTitle className="flex items-center gap-2">
                    {giphyInfo.name}
                  </CardTitle>
                  <CardDescription className="mt-2 text-muted-foreground">
                    {giphyInfo.description}
                  </CardDescription>
                </CardContent>
                <CardFooter>
                  <Button asChild className="w-full">
                    <a href={giphyInfo.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                      <span>Visitar Canal GIPHY</span>
                      <ExternalLink className="h-4 w-4" />
                    </a>
                  </Button>
                </CardFooter>
              </Card>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default JogosPage;